import _ from 'lodash';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  constructor(
    private http: HttpClient
  ) { }

  getOrganization(handle) {
    const queryParams = [
        `handle=${encodeURIComponent(handle)}`,
        `ppid=0`
      ];
    return this.http.post('/api/payee', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

}